import { Button, Typography } from '@mui/material'
import { commonBtnStyles, commonTypoStyles } from '~/constants/commonBtnStyles'
import React from 'react'
import { FcGoogle } from 'react-icons/fc'

type Props = {
  name: string
  'aria-label': string
  value: string
  onClick?: () => void
  disabled?: boolean
  className?: string
  fullWidth?: boolean
}

const GoogleBtnStyle = {
  backgroundColor: '#fff',
  // borderで対応するとdisableの時縮小して見えるのでboxShadow(inset)で対応
  boxShadow: '0 0 0 1.5px #747474 inset',
  color: '#000',
}

export const GoogleButton: React.FC<Props> = (props) => {
  const { value, ...rest } = props

  return (
    <Button
      {...rest}
      color="inherit"
      variant="contained"
      startIcon={<FcGoogle size={24} />}
      sx={{
        ...GoogleBtnStyle,
        ...commonBtnStyles,
        ':hover': { boxShadow: '0 0 0 1.5px #747474 inset' },
      }}
    >
      <Typography
        sx={{
          ...commonTypoStyles,
        }}
      >
        {value}
      </Typography>
    </Button>
  )
}
